export default __webpack_public_path__ + "static/media/come-dy.afd6556f.png";